import { Swiper, SwiperSlide } from "swiper/react"
import { Navigation } from "swiper"
import CardRecommend from "components/TypeCard/CardRecommend"
import { useEffect, useState } from "react"

const Recommend = ({ items }) => {
  const [firstSlide, setFirstSlide] = useState()

  useEffect(() => {
    const firstSlide = document.querySelector(".swiper_most_view .swiper-slide:first-child")
    setFirstSlide(firstSlide)
  }, [])

  const handleReachEnd = () => {
    if (firstSlide) {
      firstSlide.classList.add("no-margin-left")
    }
  }

  const [isMobile, setIsMobile] = useState(false)

  useEffect(() => {
    function handleResize() {
      if (window.innerWidth < 768) {
        setIsMobile(true)
      } else {
        setIsMobile(false)
      }
    }

    handleResize()

    window.addEventListener("resize", handleResize)

    return () => window.removeEventListener("resize", handleResize)
  }, [])

  if (items.length < 6) {
    return null
  }

  return (
    <div className="flex flex-col gap-4">
      <span className="max-sm:text-base max-sm:leading-[22px] text-xl font-semibold text-white">ĐỀ XUẤT</span>
      {isMobile ? (
        <div className="flex gap-3 items-center justify-center pr-4">
          <div className="flex flex-col gap-3.5">
            <CardRecommend {...items[0]} typeCard="rectangleSm" />
            <CardRecommend {...items[2]} typeCard="rectangle" />
          </div>
          <div className="flex flex-col gap-3.5">
            <CardRecommend {...items[1]} typeCard="rectangle" />
            <CardRecommend {...items[3]} typeCard="rectangleSm" />
          </div>
        </div>
      ) : (
        <div className="relative wapper__swiper__custom">
          <Swiper
            key="vod_item"
            slidesPerView={4}
            slidesPerGroup={4}
            spaceBetween={24}
            modules={[Navigation]}
            className="swiper_most_view"
            navigation={true}
            breakpoints={{
              700: {
                slidesPerView: 2.2,
                slidesPerGroup: 2
              },
              850: {
                slidesPerView: 2.5,
                slidesPerGroup: 2
              },
              920: {
                slidesPerView: 2.7,
                slidesPerGroup: 2
              },
              1000: {
                slidesPerView: 2.9,
                slidesPerGroup: 2
              },
              1070: {
                slidesPerView: 3.1,
                slidesPerGroup: 2
              },
              1140: {
                slidesPerView: 3.3,
                slidesPerGroup: 2
              },
              1200: {
                slidesPerView: 2.7,
                slidesPerGroup: 2
              },
              1301: {
                slidesPerView: 3.1,
                slidesPerGroup: 3
              },
              1440: {
                slidesPerView: 3.4,
                slidesPerGroup: 3
              },
              1550: {
                slidesPerView: 3.7,
                slidesPerGroup: 4
              },
              1680: {
                slidesPerView: 4.1,
                slidesPerGroup: 4
              },
              1825: {
                slidesPerView: 4.6,
                slidesPerGroup: 4
              }
            }}
          >
            {items.length > 0 &&
              items.slice(0, 10).map((item) => (
                <SwiperSlide key={item.id}>
                  <CardRecommend {...item} />
                </SwiperSlide>
              ))}
          </Swiper>
        </div>
      )}
    </div>
  )
}

export default Recommend
